import React, { ReactElement } from 'react';
import Styled from './Footer.styled';
import { ComponentProps } from './Footer.types';

const BoxFooter: React.FC<ComponentProps> = ({ children, ...props }): ReactElement<ComponentProps> => {
  return (
    <Styled px={4} pb={4} {...props}>
      {children}
    </Styled>
  );
};

export default BoxFooter;
